// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setManagedUsers: (state: IRootState, action: PayloadAction<IRootState['managed_users']>) => ({
    ...state,
    managed_users: action.payload,
  }),
  deleteManagedUser: (state: IRootState, action: PayloadAction<number>) => ({
    ...state,
    managed_users: state.managed_users.filter((user) => user.id !== action.payload),
  }),
  updateManagedUser: (state: IRootState, action: PayloadAction<any>) => {
    const index = state.managed_users.findIndex(u => u.id === action.payload.id);
    if (index !== -1) {
      state.managed_users[index] = {
        ...state.managed_users[index],
        ...action.payload,
      };
    }
  },
  resetManagedUsers: () => initialState,
};

export { reducers };
